export default {"src":"/_next/static/media/cross.05068114.svg","height":18,"width":18};